import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 50px;

  @media (min-width: 1200px) {
    align-items: flex-start;
    margin-top: 80px;
  }
`;

export const ListagemRecomendacoes = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing[4]}px;
  align-content: baseline;

  margin-top: 50px;

  @media (min-width: 1200px) {
    align-items: flex-start;
    margin-top: 80px;
  }

  @media (max-width: 895px) {
    justify-content: center;
  }
`;
